/**
 * rupiibet 渐进充值：默认开启 crypto 扩展（盘能力对齐 main）。
 */
export const RECHARGE_PROGRESSIVE_DEFAULT_CRYPTO_ENABLED = true;

/** rupiibet 充值主按钮渐变（`primary` #00AA96 / rgb(0, 170, 150)） */
export const RECHARGE_PROGRESSIVE_SUBMIT_BUTTON_BACKGROUND =
  'linear-gradient(rgb(0, 170, 150), rgb(0, 170, 150))';

/** 渐进余额卡不展示底部 Current Method 区（仅余额 + 头图） */
export const RECHARGE_PROGRESSIVE_BALANCE_SHOW_METHOD_SECTION = false;

/** 余额卡固定高度（rem，设计稿 16px=1rem） */
export const RECHARGE_PROGRESSIVE_BALANCE_CARD_HEIGHT_REM = 5.5;
